import {createTheme} from '@mui/material/styles';
/**
 * The initial theme deliberately preserves MUI v5 defaults so adding the root
 * provider cannot restyle existing direct MUI consumers. Homage tokens are
 * applied only by extracted components until visual standardization begins.
 */
export const designSystemTheme = createTheme();
